import { useEffect, useState } from 'react'
import { useThree } from '@react-three/fiber'
import * as THREE from 'three'

/** Follows `value` after `delayMs`, so tokens can transition left to right. */
export function useStaggered<T>(value: T, delayMs: number): T {
  const [current, setCurrent] = useState(value)
  useEffect(() => {
    if (delayMs <= 0) {
      setCurrent(value)
      return
    }
    const id = window.setTimeout(() => setCurrent(value), delayMs)
    return () => window.clearTimeout(id)
  }, [value, delayMs])
  return current
}

/**
 * DOM labels are sized in pixels while the scene scales with the viewport, so
 * scale the labels' distance factor by viewport height to keep them in
 * proportion to the objects they label.
 */
export function useLabelFactor() {
  const height = useThree((s) => s.size.height)
  return THREE.MathUtils.clamp(height / 820, 0.5, 1.25)
}
